import { render, staticRenderFns } from "./admissionLetter.vue?vue&type=template&id=9213aa78"
import script from "./admissionLetter.vue?vue&type=script&lang=js"
export * from "./admissionLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports